import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=525d565e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=525d565e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d565e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525d565e')) {
      api.createRecord('525d565e', component.options)
    } else {
      api.reload('525d565e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=525d565e&scoped=true&", function () {
      api.rerender('525d565e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Sdww1FuW5wfI/JS/comp/PopupDialog.vue"
export default component.exports